export default __webpack_public_path__ + "static/media/P900_RoHS.b7f37a78.pdf";